module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Readers love")]), _vm._v(" "), _c('span', {
    staticClass: "t3"
  }, [_vm._v("Weathering the Storm")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("by")]), _vm._v(" "), _c('span', {
    staticClass: "t4"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "t5"
  }, [_vm._v("AITLIN")]), _vm._v(" "), _c('span', {
    staticClass: "t4"
  }, [_vm._v("R")]), _c('span', {
    staticClass: "t5"
  }, [_vm._v("ICCI")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('img', {
    attrs: {
      "alt": "img1.jpg",
      "src": "Images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("“If you love stories about the coming out stage for a young teen, then this book is for you. I can honestly say that it is well told and Caitlin put her heart into it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("—MM Good Book Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("“This is a book I’d recommend to anyone looking for a gift for a gay youngster—or, really, any kid who likes horses.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("—The Book Breeze")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "t8"
  }, [_vm._v("Weathering the Storm")]), _vm._v(" "), _c('span', {
    staticClass: "t7"
  }, [_vm._v("was an excellent, well-written tale with realistic and enjoyable characters.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("—Prism Book Alliance")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47993f62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/002.vue
// module id = 57
// module chunks = 0